
import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { ShopContextStore } from 'app/shared/state/shop-context.store';

@Component({
    selector: 'app-work-in-progress',
    templateUrl: './work-in-progress.component.html',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./work-in-progress.component.scss']
})
export class WorkInProgressComponent {
  protected _shopContext = inject(ShopContextStore);

  disableWelcome = input<boolean>(false);
  subTitle = input<string>('');
  small = input<boolean>(false);
}
